<div class="content">
  <div>Current value</div>
  <div>Version's value</div>
  @for(field of compareFields; track field) {
    <ng-container>
      <div [ngClass]="{ isDiff: isDiff(field) }">{{ field | firstUpper | sanitizeStr }}</div>
      <div class="value current" [style.white-space]="'pre-wrap'">{{ getValue(current, field) }}</div>
      <div class="value" [style.white-space]="'pre-wrap'">{{ getValue(version, field) }}</div>
    </ng-container>
  }
</div>
<div class="buttons">
  <button mat-raised-button color="accent" (click)="onRevert()">Revert this version</button>
  <button class="m-l-16" mat-raised-button color="accent" (click)="onDelete()">Delete</button>
</div>
